import { EDIT_LISTING_FACILITIES,
         CLOSE_LISTING_FACILITIES,
         PENDING_SUBMIT_LISTING_FACILITIES,
         COMPLETE_SUBMIT_LISTING_FACILITIES,
         FAILED_SUBMIT_LISTING_FACILITIES
    } from "./mlTypes"


const initialState = {
    pendingsubmit: false,
    failedsubmit: false,
    completesubmit: false,
    propertyfacilitiesediting: false
}


const mlListingFacilities = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_LISTING_FACILITIES: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyfacilitiesediting: true
        }

        case CLOSE_LISTING_FACILITIES: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyfacilitiesediting: false
        }

        case PENDING_SUBMIT_LISTING_FACILITIES: return {
            ...state,
            pendingsubmit: true,
            failedsubmit: false,
            completesubmit: false
        }

        case COMPLETE_SUBMIT_LISTING_FACILITIES: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: true
        }
        
        case FAILED_SUBMIT_LISTING_FACILITIES: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: true,
            completesubmit: true
        }
    
        default: return state
    }
}

export default mlListingFacilities